import { render, staticRenderFns } from "./orderSelect.vue?vue&type=template&id=b930118e"
import script from "./orderSelect.vue?vue&type=script&lang=js"
export * from "./orderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports